import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_QUOTE = gql`
  mutation UpdateQuote($input: UpdateQuoteInput!) {
    updateQuote(input: $input) {
      vendorOpportunityId
    }
  }
`;
